import VimeoEnterpriseAbout from './_components/VimeoEnterpriseAbout';

export default function VimeoEnterprise() {
  if (devsite.user && (devsite.user.active_staff || devsite.user.account_type === 'enterprise')) {
    return <VimeoEnterpriseAbout />;
  }

  // If the user is not an active staff or enterprise account, redirect them to the start page
  window.location.assign('/api/guides/start');
  return null;
}
